export default __webpack_public_path__ + "static/media/4.78d7bde4.jpg";